module.exports = __webpack_public_path__ + "img/photo-63.8a784a85.webp";